import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import SearchBar from "../../../common/components/input/SearchBar";
import { useEffect, useState } from "react";
import { CustomMultiFilterButton } from "../../../common/components/button/CustomMultiFilterButton";
import CustomSegmentedControl from "../../../common/components/button/CustomSegmentedControl";
import CustomAccordion from "../../../common/components/accordion/CustomAccordion";
import Translate from "../../../common/translate/Translate";
import SettingsService from "../../../service/SettingsService";
import { useSearchParams } from "react-router-dom";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { C3Text } from "../../../common/components/text/CustomText";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import { Theme } from "../../../common/Theme";
import styled from "styled-components";

const EmptyStateContainer = styled(Column)`
    min-height: calc(100vh - 220px);
`;

const machineFilterValues = [
    { label: Translate("setting.faq.machine.allMachine"), value: "All Machine" },
    { label: Translate("setting.faq.machine.semiWasher"), value: "Semi Washer" },
    { label: Translate("setting.faq.machine.semiDryer"), value: "Semi Dryer" },
    { label: Translate("setting.faq.machine.proWasher"), value: "Professional Washer(Combo)" },
    { label: Translate("setting.faq.machine.proDryer"), value: "Professional Dryer" },
];

const typeValues = [
    { label: Translate("setting.faq.type.errorCode"), value: "Error Code" },
    { label: Translate("setting.faq.type.pcc"), value: "Pcc" },
    { label: Translate("setting.faq.type.userGuide"), value: "User Guide" },
];

function FAQTabContent({ onDataChange }) {
    const service = new SettingsService();
    const [searchParams, setSearchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const [searchFilter, setSearchFilter] = useState("korea");
    const [searchKeyword, setSearchKeyword] = useState("");
    const [machineFilter, setMachineFilter] = useState(["All Machine"]);
    const [selectedType, setSelectedType] = useState("Error Code");
    const [qnaData, setQnaData] = useState([]);

    const fetchGuideList = (page, pageSize, keyword) => {
        service
            .getGuideList({ page, pageSize, title: keyword || undefined })
            .then(({ result, totalCount }) => {
                const existingParams = Object.fromEntries(searchParams.entries());
                setSearchParams(
                    {
                        ...existingParams,
                        totalPage: totalCount ? Math.ceil(totalCount / pageSize) : 1,
                    },
                    { replace: true }
                );
                // GuideDto를 아코디언 형식에 맞게 매핑
                const mappedData = (result || []).map((guide) => ({
                    guideId: guide.guideId,
                    qCode: guide.code || "",
                    qText: guide.title || "",
                    aText: guide.content || "",
                    guideType: guide.guideType || "U",
                }));
                setQnaData(mappedData);
                onDataChange?.(mappedData.length > 0);
            })
            .catch((error) => {
                console.error("Error fetching guide list:", error);
            });
    };

    useEffect(() => {
        fetchGuideList(page, 20, searchKeyword);
    }, [page]);

    const onSearch = () => {
        fetchGuideList(1, 20, searchKeyword);
    };

    const handleAddFAQContent = () => {
        setSearchParams({ tab: "FAQContents", isSavePage: "true" });
    };

    if (qnaData.length === 0) {
        return (
            <EmptyStateContainer width={"100%"} alignItem={"center"} justifyContent={"center"}>
                <CustomIcon iconName={"message_square_information"} size={"32px"} />
                <SizedBox height={"12px"} />
                <C3Text fontColor={Theme.color.gray400}>No Guide yet.</C3Text>
                <SizedBox height={"16px"} />
                <PrimaryButton icon={"add_white"} text={"Add Contents"} onClick={handleAddFAQContent} />
            </EmptyStateContainer>
        );
    }

    return (
        <Column width={"100%"} padding={"32px 0"}>
            <Row width={"100%"}>
                <SearchBar
                    type={"faq"}
                    currentValue={searchFilter}
                    setValue={setSearchFilter}
                    selectorWidth={"80px"}
                    inputWidth={"220px"}
                    searchValue={searchKeyword}
                    setSearchValue={setSearchKeyword}
                    onSearchButtonClick={onSearch}
                />
                <SizedBox width={"10px"} />
                <CustomMultiFilterButton
                    icon={machineFilter.includes("All Machine") ? "filter" : "filter_active"}
                    currentValues={machineFilter}
                    setValues={setMachineFilter}
                    values={machineFilterValues}
                    multiText={"Status"}
                />
                <SizedBox width={"10px"} />
                <CustomSegmentedControl values={typeValues} currentValue={selectedType} setValue={setSelectedType} />
            </Row>
            <CustomAccordion data={qnaData} />
            <SizedBox height={"20px"} />
        </Column>
    );
}

export default FAQTabContent;
